const getPreviewButtonState = ({ isPreviewLoading, isSuggestedEditRunning }) => {
    const isPreviewButtonLoading = isPreviewLoading || isSuggestedEditRunning;
    const previewTooltip = isSuggestedEditRunning
        ? "Applying suggested edit..."
        : isPreviewLoading
            ? "Generating Preview..."
            : "Preview";

    return { isPreviewButtonLoading, previewTooltip };
};

export default getPreviewButtonState;
